import BreadcrumbTitle from "components/BreadcrumbTitle"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import {
  getBusinessUnits,
  getCategories,
  getChapters,
  getPlaces,
  getPlacesReports,
  getPlacesSummaryReports,
  getPlacesWithChapters,
} from "store/actions"
import CategoriesTab from "./categoriesTab"
import PlacesListTab from "./placesListTab"
import Select from "react-select"
import { isCrohnsClient } from "./utils"
import PlacesWithChaptersTab from "./placesWithChaptersTab"
import FavoriteReports from "./favoriteReports"

const Places = ({
  getPlaces,
  vendorId,
  getBusinessUnits,
  businessUnits,
  getCategories,
  getPlacesWithChapters,
  getChapters,
  getPlacesReports,
  getPlacesSummaryReports,
}) => {
  const TABS = {
    PLACES_LIST: 1,
    FAVORITES: 2,
    CATEGORIES: 3,
    PLACES_WITH_CHAPTERS: 4,
  }
  const [selectedBusinesUnit, setSelectedBusinessUnit] = useState({
    value: null,
    label: "Global",
  })

  useEffect(() => {
    getPlaces({
      o: "name",
      od: "asc",
      page: 1,
      per_page: 25,
    })
    getBusinessUnits()
    getCategories({ type: 2 })
    getPlacesReports({
      o: "favorite_places_count",
      od: "desc",
      page: 1,
      per_page: 25,
    })
    getPlacesSummaryReports({})
    if (isCrohnsClient(vendorId)) {
      getPlacesWithChapters({
        o: "name",
        od: "asc",
        page: 1,
        per_page: 25,
      })
      getChapters()
    }
  }, [])

  const [activeTab, setActiveTab] = useState(TABS.PLACES_LIST)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Places" />
        <Container fluid>
          <BreadcrumbTitle
            title="Places"
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Places",
                type: "tab",
                clickHandler: () => {
                  setActiveTab(TABS.PLACES_LIST)
                },
              },
              {
                title:
                  activeTab === 1
                    ? "Places List"
                    : activeTab === 2
                    ? "Favorite Reports"
                    : activeTab === 3
                    ? "Categories"
                    : "Places with chapters",
              },
            ]}
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  {businessUnits?.length > 0 && (
                    <Row className="mb-3">
                      <Col xs="auto" className="mt-2">
                        <h6>Business Unit:</h6>
                      </Col>
                      <Col xs="auto">
                        <div style={{ width: "250px" }}>
                          <Select
                            value={selectedBusinesUnit}
                            onChange={v => setSelectedBusinessUnit(v)}
                            options={[
                              { value: null, label: "Global" },
                              ...businessUnits?.map(bu => ({
                                value: bu?.id,
                                label: bu?.name,
                              })),
                            ]}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Nav pills tabs>
                    <NavLink
                      className={markIfIsActive(TABS.PLACES_LIST)}
                      onClick={() => setActiveTab(TABS.PLACES_LIST)}
                    >
                      <span style={{ fontSize: "16px" }}>Places List</span>
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.FAVORITES)}
                      onClick={() => setActiveTab(TABS.FAVORITES)}
                    >
                      <span style={{ fontSize: "16px" }}>Favorite Reports</span>
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.CATEGORIES)}
                      onClick={() => setActiveTab(TABS.CATEGORIES)}
                    >
                      <span style={{ fontSize: "16px" }}>Categories</span>
                    </NavLink>
                    {isCrohnsClient(vendorId) && (
                      <NavLink
                        className={markIfIsActive(TABS.PLACES_WITH_CHAPTERS)}
                        onClick={() => setActiveTab(TABS.PLACES_WITH_CHAPTERS)}
                      >
                        <span style={{ fontSize: "16px" }}>
                          Places with Chapters
                        </span>
                      </NavLink>
                    )}
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={TABS.PLACES_LIST}>
                      <PlacesListTab
                        selectedBusinesUnit={selectedBusinesUnit}
                      />
                    </TabPane>
                    <TabPane tabId={TABS.FAVORITES}>
                      <FavoriteReports
                        selectedBusinesUnit={selectedBusinesUnit}
                      />
                    </TabPane>
                    <TabPane tabId={TABS.CATEGORIES}>
                      <CategoriesTab />
                    </TabPane>
                    {isCrohnsClient(vendorId) && (
                      <TabPane tabId={TABS.PLACES_WITH_CHAPTERS}>
                        <PlacesWithChaptersTab />
                      </TabPane>
                    )}
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  businessUnits: state.businessUnits.businessUnits,
})

const mapDispatchToProps = dispatch => ({
  getPlaces: values => dispatch(getPlaces(values)),
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  getCategories: values => dispatch(getCategories(values)),
  getPlacesWithChapters: values => dispatch(getPlacesWithChapters(values)),
  getChapters: values => dispatch(getChapters(values)),
  getPlacesReports: values => dispatch(getPlacesReports(values)),
  getPlacesSummaryReports: values => dispatch(getPlacesSummaryReports(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Places)
